/** Earliest selectable date for all date pickers. Dates before this are disabled. */
export const GLOBAL_MIN_DATE = new Date(2026, 5, 30);

export const ALLOW_BEFORE_GLOBAL_MIN_ATTR = 'allow-before-global-min';

const normalizeDate = (time: Date): Date => {
  return new Date(time.getFullYear(), time.getMonth(), time.getDate());
};

export const isDateBeforeGlobalMin = (time: Date): boolean => {
  return normalizeDate(time).getTime() < normalizeDate(GLOBAL_MIN_DATE).getTime();
};

export const isGlobalMinDateExcluded = (attrs: Record<string, unknown>): boolean => {
  const value = attrs.allowBeforeGlobalMin ?? attrs[ALLOW_BEFORE_GLOBAL_MIN_ATTR];

  return value === true || value === '';
};

/** Returns today, or GLOBAL_MIN_DATE when today is earlier than the global minimum. */
export const getGlobalDefaultDate = (): Date => {
  const today = normalizeDate(new Date());

  if (today.getTime() < normalizeDate(GLOBAL_MIN_DATE).getTime()) {
    return new Date(GLOBAL_MIN_DATE);
  }

  return today;
};
